module.exports = __webpack_public_path__ + "static/media/4.2a0f2d09.jpg";